import {queryHttp} from "~/query/queryHttp";
import {notificationStore} from "~/stores/init";
import {requirementAttachmentUrl} from "../services/categoryProfileUrls";

/** Downloads through the authenticated API (attachments have no public URL) and saves under the original name. */
export async function downloadAttachment(databagId: number, requirementId: number, fileName: string): Promise<void> {
    try {
        const {data} = await queryHttp.get<Blob>(requirementAttachmentUrl(databagId, requirementId), {responseType: 'blob'});
        const url = URL.createObjectURL(data);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
    } catch {
        notificationStore.show('Could not download the attachment.', {severity: 'error', autoHideDuration: 4000});
    }
}
